import { PageHeader } from "components/ui";
import React from 'react';
import { Grid, Typography, Box } from "@mui/material";
import { fontFamily, fontSize } from '../../../node_modules/@mui/system/index';
import CustomButton from 'components/buttonsComponent/StyledButton';
import NavigationButtons from 'helper/navigation/NavigationButtons';

const WhatisWb = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <PageHeader
                        title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards"
                    />
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box className="gri-header">
                    <NavigationButtons imageKey="WB" title={"WB Reporting"} activeStep={0} />
                </Box>
            </Grid>
            <Box
                sx={{
                    borderRadius: '8px',
                    padding: '24px',
                    top: '226px',
                    left: '75px',
                }}
            >
                <Box sx={{ mb: 2 }}>
                    <Typography
                        component="h4"
                        sx={{
                            fontFamily: 'DM Sans',
                            fontWeight: 800,
                            fontSize: '20px',
                            lineHeight: '28px',
                            letterSpacing: '-2%',
                            color: '#4F4F4F',
                            mb: 1,
                        }}
                    >
                        What is WB Safeguard Policy?
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            fontFamily: 'DM Sans',
                            fontWeight: 400,
                            fontSize: '20px',
                            lineHeight: '28px',
                            letterSpacing: '-2%',
                            color: '#4F4F4F',
                        }}
                    >
                        The World Bank Safeguard Policy is defined as a formal set of environmental and social operational policies and procedures designed to ensure that World Bank-financed projects avoid, minimize, or mitigate adverse environmental and social impacts, while enhancing positive development outcomes.
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            fontFamily: 'DM Sans',
                            fontWeight: 400,
                            fontSize: '20px',
                            lineHeight: '28px',
                            letterSpacing: '-2%',
                            color: '#4F4F4F',
                        }}
                    >
                        It establishes mandatory standards for project planning, implementation, and monitoring across areas such as environmental assessment, involuntary resettlement, Indigenous Peoples, natural habitats, pest management, cultural heritage, dam safety, international waterways, and projects in disputed areas.
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            fontFamily: 'DM Sans',
                            fontWeight: 400,
                            fontSize: '20px',
                            lineHeight: '28px',
                            letterSpacing: '-2%',
                            color: '#4F4F4F',
                        }}
                    >
                        The Safeguard Policy ensures that all financed activities align with principles of sustainability, social inclusion, risk management, and stakeholder engagement, and it serves as a foundation for protecting both people and the environment from unintended project harms. Although the World Bank has shifted to the newer Environmental and Social Framework (ESF) for most new projects, the Safeguard Policy remains applicable to earlier projects approved under the previous system.                    </Typography>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {/* <CustomButton title="Access Full SASB Standards Documentation"
                    route="/reporting/whatisgri"
                /> */}

                <a
                    href="https://www.worldbank.org/en/projects-operations/environmental-and-social-framework"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                >
                    <CustomButton title="Access to full WB Disclosure Document" />
                </a>

            </Box>
        </Grid >
    );
};

export default WhatisWb;